import React, { FC } from "react";
import styled from "styled-components";
import { mediaObj } from "../../../../styles/Media";

interface Props {
  children: JSX.Element;
}

const Constaint: FC<Props> = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Constaint;

const Wrapper = styled.div`
  /* max-width: 1240px; */
  margin-left: auto;
  margin-right: auto;
  /* padding: 0 5.25rem; */ //removed old one
  padding: 0 2.25rem; //new one
  height: 100%;
  max-width: 1440px;

  @media (min-width: 1200px) {
    padding: 0 2.25rem;
  }

  ${mediaObj.smallDesktop} {
    padding: 0 5%;
  }

  ${mediaObj.mobile} {
    padding: 0 1.25rem;
  }
`;
